import type { IPlatformLogger, ModuleLoader } from '@wix/thunderbolt-symbols'
import type { BootstrapData } from '../../types'
import type { IBuilderComponentSdkLoader } from '../types'
import { createSsrBuilderComponentSdkLoader } from './builderComponentSdkLoaders/ssrBuilderComponentSdkLoader'
import {
	createClientBuilderComponentSdkLoader,
	updateClientImportMap,
} from './builderComponentSdkLoaders/clientBuilderComponentSdkLoader'
import { BOOTSTRAP_DATA, MODULE_LOADER, BUILDER_COMPONENT_SDK_LOADER, PLATFORM_LOGGER } from './moduleNames'

const BuilderComponentSdkLoader = (
	bootstrapData: BootstrapData,
	moduleLoader: ModuleLoader,
	logger: IPlatformLogger
): IBuilderComponentSdkLoader => {
	const { builderPublicPackagesUrls, builderComponentsImportMapSdkUrls } = bootstrapData
	const isSSR = !process.env.browser

	// Store initial import map URLs for client-side loader
	if (!isSSR && builderComponentsImportMapSdkUrls) {
		updateClientImportMap(builderComponentsImportMapSdkUrls)
	}

	return isSSR
		? createSsrBuilderComponentSdkLoader(
				moduleLoader,
				builderPublicPackagesUrls,
				builderComponentsImportMapSdkUrls,
				logger
			)
		: createClientBuilderComponentSdkLoader(builderPublicPackagesUrls)
}

export default {
	factory: BuilderComponentSdkLoader,
	deps: [BOOTSTRAP_DATA, MODULE_LOADER, PLATFORM_LOGGER],
	name: BUILDER_COMPONENT_SDK_LOADER,
}
